import React, {forwardRef} from 'react';

import {cn} from '../lib/utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

// Visual states only. The primitive owns no form state and renders no
// validation message: `aria-invalid` and the native `disabled` attribute are
// supplied by the consumer and drive the styling from the DOM.
const inputStyles = [
  'block h-9 w-full rounded-md border px-3 text-sm',
  'border-(--compass-border) bg-(--compass-surface) text-(--compass-on-surface)',
  'placeholder:text-(--compass-on-muted)',
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--compass-focus-ring)',
  'aria-[invalid=true]:border-(--compass-border-invalid)',
  'aria-[invalid=grammar]:border-(--compass-border-invalid)',
  'aria-[invalid=spelling]:border-(--compass-border-invalid)',
  'disabled:cursor-not-allowed disabled:border-transparent',
  'disabled:bg-(--compass-disabled-surface) disabled:text-(--compass-disabled-foreground)',
];

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  {className, type = 'text', ...props},
  ref
) {
  return (
    <input
      {...props}
      data-compass-input=""
      type={type}
      className={cn(inputStyles, className)}
      ref={ref}
    />
  );
});
